module.exports = __webpack_public_path__ + "img/tiktok.2718b604.png";